import { Button, PublicShell } from '@concord/ui';
import { useNavigate } from 'react-router';

export function NotFound() {
  const navigate = useNavigate();
  return (
    <PublicShell narrow>
      <div className="panel">
        <div className="pbody" style={{ display: 'flex', flexDirection: 'column', gap: '.8rem' }}>
          <h1 style={{ margin: 0, fontSize: '1.3rem', fontWeight: 680, letterSpacing: '-.025em' }}>
            Page not found
          </h1>
          <p style={{ margin: 0, color: 'var(--ink-2)' }}>The link may be out of date.</p>
          <Button onClick={() => navigate('/')} style={{ alignSelf: 'flex-start' }}>
            Go to my home page
          </Button>
        </div>
      </div>
    </PublicShell>
  );
}
